module.exports = __webpack_public_path__ + "static/media/banner-harinaselizondo(1).2d77aad8.jpg";